import withAPIAction from 'helpers/withAPIAction'
import {
  SupplierListReq,
  CreateSupplierReq,
  UpdateSupplierReq,
  DeleteSupplierReq,
  SupplierDetailReq,
} from './types'
import {
  getSupplierListAction,
  createSupplierAction,
  updateSupplierAction,
  deleteSupplierAction,
  getSupplierDetailAction,
  getAllSupplierListAction,
} from './actions'
import { APIPath } from 'services/APIPath'
import { appConfig } from 'config'

export const supplierListAPI = (data: SupplierListReq, token: string, xmid: any) => {
  return withAPIAction<SupplierListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.supplierList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getSupplierListAction)
}

export const allSupplierListAPI = (data: SupplierListReq, token: string, xmid: any) => {
  return withAPIAction<SupplierListReq>({
    method: 'POST',
    baseUrl: appConfig.backofficeEndpoint,
    path: `${APIPath.supplierList}`,
    data,
    token,
    xmid,
    // hideOath: true,
  })(getAllSupplierListAction)
}

export const createSupplierAPI = (data: CreateSupplierReq, token: string, xmid: string) => {
  return withAPIAction<CreateSupplierReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.createSupplier,
    data,
    token,
    xmid,
  })(createSupplierAction)
}

export const updateSupplierAPI = (data: UpdateSupplierReq, token: string, xmid: string) => {
  return withAPIAction<UpdateSupplierReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.updateSupplier,
    data,
    token,
    xmid,
  })(updateSupplierAction)
}

export const deleteSupplierAPI = (data: DeleteSupplierReq, token: string, xmid: string) => {
  return withAPIAction<DeleteSupplierReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.deleteSupplier,
    data,
    token,
    xmid,
  })(deleteSupplierAction)
}

export const getSupplierDetailAPI = (data: SupplierDetailReq, token: string, xmid: string) => {
  return withAPIAction<SupplierDetailReq>({
    method: 'POST',
    baseUrl: appConfig.apiGrpcEndpoint,
    path: APIPath.getSupplierByID,
    data,
    token,
    xmid,
  })(getSupplierDetailAction)
}
